import React from 'react';
import cx from 'classnames';
import useBuildVariantProps from '../../../../modules/theme/useBuildVariantProps';
import styles from './TableRow.module.scss';
import type { TableRowProps } from './TableRow.types';

const TableRow = (props: TableRowProps) => {
  const {
    className,
    children,
    ...otherProps
  } = props;

  const variantProps = useBuildVariantProps(
    'table-row',
    {},
    {},
  );

  return (
    <tr className={cx(styles.tableRow, className)} { ...otherProps } { ...variantProps }>
      {children}
    </tr>
  );
};
export default TableRow;
